export enum NotificationSettings {
  ALL = 1,
  EMAIL,
  SMS,
}
